import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GraphQLModule } from '@app/@graphql';
import { IfLoggedDirective, IfAdminOverridenDirective } from './directives';

@NgModule({ declarations: [IfLoggedDirective, IfAdminOverridenDirective],
    exports: [IfLoggedDirective, IfAdminOverridenDirective], imports: [CommonModule, GraphQLModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CoreAuthModule {}
